import React from 'react';

import classes from './NavigationItems.module.css';

import NavigationItem from './NavigationItem/NavigationItem';

const NavigationItems = (props) => {
	let navItems = [
		<NavigationItem
			clicked={props.itemsClicked}
			key="BurgerZone"
			link="/"
			exact
		>
			BurgerZone
		</NavigationItem>,
	];

	if (props.isAuthenticated) {
		navItems.push(
			<NavigationItem clicked={props.itemsClicked} key="Orders" link="/orders">
				Orders
			</NavigationItem>,
			<NavigationItem clicked={props.itemsClicked} key="Logout" link="/logout">
				Logout
			</NavigationItem>
		);
	} else {
		navItems.push(
			<NavigationItem
				clicked={props.itemsClicked}
				key="SignIn"
				link="/user/signin"
			>
				Sign In
			</NavigationItem>
		);
	}

	return <ul className={classes.NavigationItems}>{navItems}</ul>;
};

export default NavigationItems;
